import React, {useEffect, useRef, useState} from "react";
import {Outlet} from "react-router-dom";
import {FiMenu} from "react-icons/fi";
import AppHeader from "../AppHeader/AppHeader";
import Sidebar from "../sidebar/sidebar";
import "./AppLayout.css";

export default function AppLayout() {
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const hamburgerRef = useRef(null);

    const openSidebar = () => setMobileSidebarOpen(true);
    const closeSidebar = () => setMobileSidebarOpen(false);

    useEffect(() => {
        if (!mobileSidebarOpen) return undefined;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        const closeOnEscape = (event) => {
            if (event.key !== "Escape") return;
            setMobileSidebarOpen(false);
            window.setTimeout(() => hamburgerRef.current?.focus(), 0);
        };
        document.addEventListener("keydown", closeOnEscape);
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener("keydown", closeOnEscape);
        };
    }, [mobileSidebarOpen]);

    return (
        <div className="app-layout">
            <AppHeader/>

            {/* ✅ همبرگری زیر هدر (فقط موبایل) */}
            <div className="mobile-subbar">
                <button
                    ref={hamburgerRef}
                    className="mobile-hamburger"
                    onClick={openSidebar}
                    aria-label={mobileSidebarOpen ? "بستن منوی اصلی" : "باز کردن منوی اصلی"}
                    aria-expanded={mobileSidebarOpen}
                >
                    <FiMenu aria-hidden="true"/>
                </button>
            </div>

            {/* overlay فقط موبایل */}
            <div
                className={`sidebar-overlay ${mobileSidebarOpen ? "show" : ""}`}
                onClick={closeSidebar}
            />

            <div className="app-shell">
                <Sidebar mobileOpen={mobileSidebarOpen} onCloseMobile={closeSidebar}/>
                <main className="app-main">
                    <Outlet/>
                </main>
            </div>
        </div>
    );
}
